export const countUniquePageVisitsOnSessionId = {
  analysisType: 'count_unique',
  eventCollection: 'kb.page.view',
  key: 'countUniquePageVisitsOnSessionId',
  targetProperty: 'actor.session.id',
}
